module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAGCAYAAADKfB7nAAAABGdBTUEAALGPC/xhBQAAAIhJREFUGBljXLhwofCvX7/W/v//X42RkfEWNzd3SFRU1BsGLGDZsmUiX79+XQNVe5ONjS2EEaQO3RCgRHB8fPxbZDNwqQEbQMgQXJpB+uAG4DIEJI7sRXTXoRiAbggTE9MdkNi/f/9UQOGDrhkkh2EASBAUWN++fVsH0gjigwxiZWUNRA8XkBwAJ211/YbLUywAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/arrow-down-gray.png
// module id = 93
// module chunks = 35783957827783